import { Component } from 'react';
import findIdByPath from '../utils/findIdByPath';

class BookLoader extends Component {
  componentDidMount() {
    const {
      fetchBookIfNeeded,
      hasFetchedReflections,
      fetchReflectionsIfNeeded
    } = this.props;

    // Fetch book
    fetchBookIfNeeded(findIdByPath());

    // Fetch reflections
    if (!hasFetchedReflections) fetchReflectionsIfNeeded();
  }

  render() {
    return null;
  }
}

export default BookLoader;



// WEBPACK FOOTER //
// ./src/components/BookLoader.js